module.exports = __webpack_public_path__ + "img/prove5.50b97419.png";